import {websiteEntry} from './entry-route';
import './entry.css';

switch (websiteEntry(window.location.pathname)) {
    case 'games': void import('./games'); break;
    case 'account': void import('./account'); break;
    case 'share': void import('./share'); break;
    default: void import('./marketing');
}
